import { t as i18n } from 'i18next';
import { z } from 'zod';

const requiredFieldError = i18n('common.validation.requiredField');
const invalidEmailError = i18n('common.validation.invalidEmail');
const invalidPhoneError = i18n('common.validation.invalidPhone');

export const addClientSchema = z.object({
  first_name: z.string({ required_error: requiredFieldError }).min(1, { message: requiredFieldError }).max(100),
  last_name: z.string({ required_error: requiredFieldError }).min(1, { message: requiredFieldError }).max(100),
  email: z.string({ required_error: requiredFieldError })
    .email({ message: invalidEmailError }).min(1, { message: requiredFieldError }).max(100),
  mobile: z.object({
    inputValue: z.string({ required_error: invalidPhoneError }).min(
      1,
      { message: requiredFieldError }
    ).max(100),
  }),
});
